import { useTranslation } from 'react-i18next';
import RevealWrapper from '@/pages/home/components/RevealWrapper';

const FEATURES = [
  { code: '01', icon: 'ri-wifi-off-line',    titleKey: 'dk.f1.title', descKey: 'dk.f1.desc', tagKey: 'dk.f1.tag' },
  { code: '02', icon: 'ri-user-line',         titleKey: 'dk.f2.title', descKey: 'dk.f2.desc', tagKey: 'dk.f2.tag' },
  { code: '03', icon: 'ri-file-text-line',    titleKey: 'dk.f3.title', descKey: 'dk.f3.desc', tagKey: 'dk.f3.tag' },
  { code: '04', icon: 'ri-bar-chart-2-line',  titleKey: 'dk.f4.title', descKey: 'dk.f4.desc', tagKey: 'dk.f4.tag' },
  { code: '05', icon: 'ri-shield-check-line', titleKey: 'dk.f5.title', descKey: 'dk.f5.desc', tagKey: 'dk.f5.tag' },
  { code: '06', icon: 'ri-smartphone-line',   titleKey: 'dk.f6.title', descKey: 'dk.f6.desc', tagKey: 'dk.f6.tag' },
];

export default function FeaturesBlock() {
  const { t } = useTranslation();

  return (
    <section className="relative bg-[#070b12] border-t border-sky-200/10 overflow-hidden">
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            'radial-gradient(circle at 18% 14%, rgba(56,189,248,0.08) 0%, rgba(56,189,248,0) 40%), radial-gradient(circle at 84% 22%, rgba(37,99,235,0.09) 0%, rgba(37,99,235,0) 42%)',
        }}
      />
      <div
        className="absolute inset-0 pointer-events-none opacity-[0.2]"
        style={{
          backgroundImage:
            'linear-gradient(rgba(148,163,184,0.08) 1px, transparent 1px), linear-gradient(90deg, rgba(148,163,184,0.08) 1px, transparent 1px)',
          backgroundSize: '88px 88px',
        }}
      />

      <div className="relative z-10 px-6 lg:px-14 py-8 border-b border-sky-200/10 flex items-center justify-between">
        <span className="font-mono text-xs text-slate-400 tracking-widest uppercase">{t('dk.features.label')}</span>
        <span className="font-mono text-xs text-slate-500">{FEATURES.length} items</span>
      </div>

      <div className="relative z-10 grid md:grid-cols-2 lg:grid-cols-3 border-t border-l border-sky-300/[0.14]">
        {FEATURES.map((f, idx) => (
          <RevealWrapper key={f.code} direction="up" delay={idx * 80} threshold={0.1} className="h-full border-r border-b border-sky-300/[0.14]">
            <div className="bg-[#0b1421] p-10 lg:p-14 group hover:bg-[#101c2d] transition-colors duration-300 h-full">
              <div className="flex items-start justify-between mb-8">
                <div className="w-12 h-12 border border-sky-200/15 bg-slate-900/45 flex items-center justify-center group-hover:border-sky-200/30 transition-colors duration-300">
                  <i className={`${f.icon} text-xl text-slate-400 group-hover:text-sky-100 transition-colors duration-300`} />
                </div>
                <span className="font-mono text-[10px] text-slate-500 border-sky-200/10 border px-2 py-1 tracking-widest">{t(f.tagKey)}</span>
              </div>
              <div className="font-black text-4xl text-slate-200/10 group-hover:text-slate-200/20 transition-colors duration-300 leading-none mb-5">{f.code}</div>
              <h3 className="text-lg font-black text-white mb-4 tracking-tight">{t(f.titleKey)}</h3>
              <p className="text-slate-400 text-sm leading-loose">{t(f.descKey)}</p>
            </div>
          </RevealWrapper>
        ))}
      </div>
    </section>
  );
}
